import {ParityMainHotelsProvider, ParitySubmittedFiltersProvider, ParityReportExecutionProvider} from "./@contexts"
import React from "react"


export default function ParityProviders({ children }) {


    return <ParityReportExecutionProvider>
        <ParityMainHotelsProvider>
            <ParitySubmittedFiltersProvider>
                {children}
            </ParitySubmittedFiltersProvider>
        </ParityMainHotelsProvider>
    </ParityReportExecutionProvider>
}

export { ParitySubmittedFiltersContext, ParityReportExecutionContext } from "./@contexts"